import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yuancheng",
  "use": "icon-yuancheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yuancheng\"><path d=\"M754.986667 389.973333H573.12v-104.853333L363.626667 424.746667l209.493333 139.626666v-104.746666h174.506667a87.253333 87.253333 0 0 1 5.76 174.4h-564.266667V215.253333h628.373333V320h69.76V180.373333a34.773333 34.773333 0 0 0-34.88-34.88H154.24a34.88 34.88 0 0 0-34.986667 34.88v488.746667A34.986667 34.986667 0 0 0 154.24 704h314.133333v104.746667H258.88v69.76h488.746667v-69.76H538.133333V704h209.493334a157.12 157.12 0 0 0 7.36-314.026667z\" p-id=\"1240\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yuancheng.svg
// module id = Hgxa
// module chunks = 68